import querystring from 'querystring'
import {getConsole} from 'lib/getConsole'
const console = getConsole('lib', 'hotnessNotifier')
let ranOnce = false

const params = querystring.parse(window.location.search.substring(1))

const displayHotness = (versionString) => {
  console.log(`🌶 hot param active on pageload, using rwgps-ui@${versionString}`)
  const div = document.createElement('div')
  div.style.cssText = `
    position: fixed;
    z-index: 9002;
    bottom: 0;
    right: 0;
    font-size: 12px;
    font-family: Menlo, monospace;
    background: #FFF;
    color: #3d3d3d;
    padding: 10px 15px;
    border-radius: 3px 0 0 0;
    box-shadow: 0 0 7px 2px rgba(0,0,0,0.1);
    cursor: pointer;
  `
  div.innerText = `🌶 \xa0using rwgps-ui version ${versionString}`
  div.addEventListener('click', (e) => e.target.remove())
  document.body.appendChild(div)
}

(() => {
  if (params.hot && !ranOnce) {
    ranOnce = true

    if (!document.currentScript) {
      // crappy browser that doesn't support currentScript, bail out
      displayHotness('unknown source')
      return
    }
    const src = document.currentScript.src
    if (src.includes('localhost') || src.includes('ridewithgps.local')) {
      displayHotness('localhost')
    } else {
      const version = src.match(/\/([a-z0-9]{7,}(-pr)?)-[a-z0-9.-]+\.js/)
      version
        ? displayHotness(version[1])
        : displayHotness('unknown')
    }
  }
})()
